import { useCallback } from 'react';
import { log } from 'log';
import { prop } from 'ramda';

import { getTemporaryAuthenticationToken } from '@core/js/hooks/auth/server';
import { useAppSelector } from '@core/js/store/hooks';
import { getURLParams, serialize } from '@core/js/utils/url.util';

export const useGetBingoQueryUrl = (code: string) => {
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async (dataGame, userName, sessionToken) => {
        try {
            const { queryString: rawQueryString, bingoGameType = '' } = dataGame;
            const token = (await getTemporaryAuthenticationToken({
                userName, casinoName, serviceType: 'GamePlay', sessionToken
            }))?.data.token;

            return `?${serialize({
                ...getURLParams(rawQueryString),
                ...{
                    token: `${userName}:${token}`,
                    gameName: code,
                    gameType: bingoGameType
                }
            })}`;
        } catch (error) {
            log('error', error);
        }
    }, [casinoName, code]);
};
